import { render, staticRenderFns } from "./Words.vue?vue&type=template&id=0a863660&scoped=true&"
import script from "./Words.vue?vue&type=script&lang=js&"
export * from "./Words.vue?vue&type=script&lang=js&"
import style0 from "./Words.vue?vue&type=style&index=0&id=0a863660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a863660",
  null
  
)

export default component.exports